import React from 'react';
import { useTranslation as useOriginalTranslation } from 'react-i18next';

export const useTranslation = () => {
  const { t: originalT, ...rest } = useOriginalTranslation();
  
  const t = (key: string, options?: any): string | React.ReactElement => {
    const translation = originalT(key, options);
    
    // 如果包含换行标签，返回JSX元素
    if (typeof translation === 'string' && (translation.includes('<br>') || translation.includes('<br/>') || translation.includes('<br />'))) {
      return (
        <span dangerouslySetInnerHTML={{ __html: translation }} />
      );
    }
    
    return translation as string;
  };
  
  return { t, ...rest };
};